import { Dispatch, SetStateAction } from 'react';
import { useTranslation } from 'react-i18next';
import { GeojsonSchema } from '@/types/types';
import Button from '../ui/general/Button';
import Table from '../ui/data-display/Table';
import Modal from '../ui/feedback/Modal';

export default function GeojsonSelectModal({
  visible,
  setVisible,
  selectGeojsonEvent,
  geojsons,
}: {
  visible: boolean;
  setVisible: Dispatch<SetStateAction<boolean>>;
  selectGeojsonEvent: (val: GeojsonSchema) => void;
  geojsons: GeojsonSchema[];
}) {
  const { t } = useTranslation();

  const columns = [
    {
      title: t('NAME'),
      key: 'name',
      render: (record: GeojsonSchema) => (record.name),
    },
    {
      title: t('ACTION'),
      key: 'action',
      render: (record: GeojsonSchema) => (
        <div className="flex gap-4 items-center">
          <Button
            size="small"
            onClick={() => {
              selectGeojsonEvent(record);
            }}
          >
            {t('SELECT')}
          </Button>
        </div>
      ),
    },
  ];

  return (
    <Modal
      title={`${t('SELECT')} GeoJSON`}
      isOpen={visible}
      setIsOpen={setVisible}
      width={900}
    >
      <div>
        <Table
          columns={columns}
          dataSource={geojsons}
          isLoading={false}
        />
      </div>
    </Modal>
  );
}
